var map = {
	"./desktop-bzgl.png": "c0d5",
	"./desktop-clssdw.png": "1c60",
	"./desktop-gdtj.png": "c325",
	"./desktop-gis.png": "543e",
	"./desktop-gwgl.png": "2e42",
	"./desktop-gzxjck.png": "b9bc",
	"./desktop-htgl.png": "d391",
	"./desktop-jsgl.png": "a9ac",
	"./desktop-rygl.png": "a917",
	"./desktop-sbgl.png": "90f3",
	"./desktop-sjdp.png": "3103",
	"./desktop-xmgl.png": "c7f2",
	"./desktop-xmlx.png": "9b7b",
	"./desktop-xmsp.png": "bb1f",
	"./desktop-zhgl.png": "8e5d",
	"./desktop-zzjggl.png": "8fba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "17a8";